var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiplyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM10.1006 5.25195C9.94437 5.09614 9.69125 5.09594 9.53516 5.25195L7.99902 6.78711L6.46387 5.25195C6.30764 5.09627 6.05448 5.09598 5.89844 5.25195L5.25195 5.89844C5.096 6.05449 5.09628 6.30765 5.25195 6.46387L6.78711 7.99902L5.25195 9.53516C5.09607 9.69126 5.09618 9.94441 5.25195 10.1006L5.89844 10.7471C6.05458 10.9032 6.30764 10.9031 6.46387 10.7471L7.99902 9.21094L9.53516 10.7471C9.69134 10.9033 9.94437 10.9032 10.1006 10.7471L10.7471 10.1006C10.9032 9.94437 10.9033 9.69134 10.7471 9.53516L9.21094 7.99902L10.7471 6.46387C10.9032 6.30765 10.9033 6.05462 10.7471 5.89844L10.1006 5.25195Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplyCircle);
export default __webpack_public_path__ + "static/media/multiply-circle.c254ae9899cf843ca4a2ead4cd4cec92.svg";
export { ForwardRef as ReactComponent };